import { useEffect, useState } from "react";
import "./ElectronicAssistant.scss";
import { IconClose, IconMessage, IconPayments, IconSearch, IconSendDocument } from "../Icons/Icons.mjs";
import Messages from "../Messages/Messages.mjs";
import SendMessage from "../SendMessage/SendMessage.mjs";
import { useDispatch, useSelector } from "react-redux";
import Search from "../Search/Search.mjs";
import InputFile from "../UI/InputFile/InputFile.mjs";
import { IconSendPhoto } from "../Icons/Icons.mjs";
import Payment from "../Payment/Payment.mjs";
export default function ElectronicAssistant({}) {
  const [mode, setMode] = useState(localStorage.getItem("site-helper-mode") || 0);
  // const [mode, setMode] = useState(2);
  const icons = [IconMessage, IconPayments, IconSearch];
  const messagesStore = useSelector((state) => state.messages);
  const sessionStore = useSelector((state) => state.session);
  const dispatch = useDispatch();
  // console.log("ElectronicAssistant");

  return mode == 0 ? (
    <div
      className={`electronic-assistant electronic-assistant_closed`}
      onClick={() => {
        // setMode(localStorage.getItem("site-helper-mode") || 1);
        setMode(1);
        localStorage.setItem("site-helper-mode", 1);
      }}
    >
      <img className="logo" src={`${process.env.REACT_APP_FULL_PUBLIC_URL}/images/icon.jpg`} />
      <div>
        <h3>Умный помощник</h3>
        <h4>Помогу с вопросами</h4>
      </div>
    </div>
  ) : (
    <div className={`electronic-assistant`}>
      <div className="electronic-assistant__tools">
        <img className="logo" src={`${process.env.REACT_APP_FULL_PUBLIC_URL}/images/icon.jpg`} />
        <div className="electronic-assistant__tools__modes">
          <div
            className={`tab tab${mode == 1 ? "_active" : ""}`}
            onClick={() => {
              setMode(1);
              localStorage.setItem("site-helper-mode", 1);
            }}
          >
            <IconMessage classSvg={`icon${mode == 1 ? "_active" : ""}`} />
            <div>Чат</div>
          </div>

          {/* <div
            className={`tab tab${mode == 2 ? "_active" : ""}`}
            onClick={() => {
              setMode(2);
              localStorage.setItem("site-helper-mode", 2);
            }}
          >
            <IconPayments classSvg={`icon${mode == 2 ? "_active" : ""}`} />
            <div>Оплата</div>
          </div>

          <div
            className={`tab tab${mode == 3 ? "_active" : ""}`}
            onClick={() => {
              setMode(3);
              localStorage.setItem("site-helper-mode", 3);
            }}
          >
            <IconSearch classSvg={`icon${mode == 3 ? "_active" : ""}`} />
            <div>Поиск</div>
          </div> */}
        </div>
      </div>
      <div className="electronic-assistant__close-panel">
        {mode == 1 ? (
          <IconMessage classSvg="icon_active" />
        ) : mode == 2 ? (
          <IconPayments classSvg="icon_active" />
        ) : (
          <IconSearch classSvg="icon_active" />
        )}
        <div
          onClick={() => {
            // localStorage.setItem("site-helper-mode", mode);
            setMode(0);
            localStorage.setItem("site-helper-mode", 0);
          }}
          className="div-close"
        >
          <div>Закрыть</div>
          <IconClose classSvg="cursor-pointer close-btn" />
        </div>
      </div>
      {mode == 1 ? (
        <>
          <Messages />
          <SendMessage />
        </>
      ) : mode == 2 ? (
        <div className="electronic-assistant__payments">
          <Payment />
        </div>
      ) : (
        <div className="electronic-assistant__search">
          <Search />
        </div>
      )}
    </div>
  );
}
